var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.516128540039062,
    height: 16.500030517578125,
    viewBox: "0 0 16.516128540039062 16.500030517578125",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25896 14.9817C11.9799 14.9817 14.9978 11.9674 14.9978 8.25001C14.9978 4.53266 11.9817 1.51834 8.25896 1.51834C4.53802 1.51834 1.52013 4.53266 1.52013 8.25001C1.52192 11.9674 4.53802 14.9817 8.25896 14.9817ZM8.25896 16.25C3.83677 16.25 0.25 12.6686 0.25 8.25001C0.25 3.8314 3.83498 0.25 8.25896 0.25C12.6811 0.25 16.2661 3.8314 16.2661 8.25001C16.2679 12.6686 12.6811 16.25 8.25896 16.25Z",
    stroke: "rgba(18, 185, 129, 1)",
    strokeWidth: 0.5,
    fill: "#12B981"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6382 5.87261C11.3824 5.62753 10.9728 5.63826 10.7277 5.89407L7.57203 9.20714L5.83678 7.11948C5.60959 6.84756 5.20172 6.81 4.9298 7.0354C4.65789 7.26259 4.62032 7.67047 4.84572 7.94238L7.04073 10.5828C7.16416 10.7313 7.34126 10.81 7.52015 10.8136L7.57024 10.8136C7.72946 10.8064 7.88688 10.7402 8.00674 10.615L11.6597 6.78137C11.9048 6.52735 11.8958 6.11769 11.6382 5.87261Z",
    stroke: "rgba(18, 185, 129, 1)",
    strokeWidth: 0.5,
    fill: "#12B981"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/对号2.70fd1d559727d7b03815604c7f8f0075.svg";
export { ForwardRef as ReactComponent };